import BtnDefault from '../default/BtnDefault'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode
    icon?: string
    iconSize?: string
    iconRight?: string
    variant?: "primary" | "outline-primary" | "secondary" | "outline-secondary" | "success" | "outline-success" | "danger" | "outline-danger" | "warning" | "outline-warning" | "info" | "outline-info" | "light" | "outline-light" | "dark" | "outline-dark" | "link"
    tintColor?: string
}

function BtnPrimary({children, variant = "primary", ...rest}: ButtonProps) {
    return (
        <BtnDefault variant={variant}  {...rest}>
            {children}
        </BtnDefault>
    )
}

export default BtnPrimary
